<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Departments</span>
    </div>
    <div nz-col nzSpan="8" >
        <div class="search-container" *ngIf="currentUser.Is_Partner">  
            <nz-input-group [nzPrefix]="searchIcon">
                <input
                    nz-input
                    type="text"
                    placeholder="Enter minimum 3 characters to search..."
                    [(ngModel)]="searchText"                    
                    class="search-box"
                />
            </nz-input-group>
            <ng-template #searchIcon>
                <i nz-icon nzType="search" style="color: #0b2d71;"></i>
            </ng-template>   
        </div>
    </div>
    <div nz-col nzSpan="10">
        <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button nzType="primary" (click)="showCreateModal()">
                <i nz-icon nzType="file-add" nzTheme="outline"  style="color: white;"></i> Add New Department
            </button>
        </div>
    </div>
</div> 
<div class="Layoutcontainer">    
    <!-- New -->
    <div class="row" style="margin: 0;">
        <nz-table [nzSize]="'small'" #departmentTable  [nzData]="departmentMaster" class="table table-bordered table-striped table-textCenter table-sm" aria-describedby="row">
            <thead>
                <tr>
                    <th class="thead text-center" style="padding: 5px;">Department Name</th>
                    <th class="thead text-center" style="padding: 5px;">Sub Department</th>
                    <th class="thead text-center" style="padding: 5px;">Status</th>
                    <th class="thead text-center" style="padding: 5px;">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let department of departmentTable.data ">
                    <td class="text-center font-bold">{{department.Department_Name}}</td>
                    <td >
                        <ul style="margin-top: 10px;;">
                        <li *ngFor="let subDept of department.SubDepartments |  orderby: sortingSubDeptName" style="font-size: 12px; line-height: 5px;">
                            {{subDept.Sub_Dept_Name}}
                        </li>
                        </ul>
                    </td>
                    <td class="text-center">{{department.Active ? "Active" : "Inactive"}}</td>
                    <td class="text-center">
                        <div *ngIf="department.Active" class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;"> 
                            <button  nz-button nzType="primary" [nzSize]="'small'" style="margin-right: 5px;" (click)="showEditModal(department)">
                                <i nz-icon nzType="edit" nzTheme="outline"  style="color: white;"></i> Edit
                            </button>  
                            <button nz-button nzType="primary" [nzSize]="'small'" nzDanger (click)="showDeactivateModal(department)" >
                                <i nz-icon nzType="stop"  style="color: white;"></i> De-Activate
                            </button> 
                        </div>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>




<nz-modal [(nzVisible)]="isVisible" nzTitle="{{ isEditMode ? 'Edit Department' : 'Add New Department' }}" (nzOnCancel)="handleCancel()" [nzClosable]="false">
    <div *nzModalContent>
      <div class="row form-group">
        <div class="col-md-4">
          <label class="required">Department Name<span class="text-danger">*</span></label>
        </div>
        <div id="departmentFormDiv" class="col-md-8">
          <form [formGroup]="departmentForm">
            <input
              nz-input
              formControlName="departmentName"
              type="text"
              class="form-control"
              placeholder="Enter Department Name"
            />
            <div class="text-danger">{{duplicateRecordMessge}}</div>
            <!-- Validation Messages -->
            <div *ngIf="departmentForm.get('departmentName')?.touched && departmentForm.get('departmentName')?.invalid">
              <small class="text-danger" *ngIf="departmentForm.get('departmentName')?.errors?.['required']">
                Department Name is required.
              </small>
              <small class="text-danger" *ngIf="departmentForm.get('departmentName')?.errors?.['maxlength']">
                Department Name cannot exceed 50 characters.
              </small>
              <small class="text-danger" *ngIf="departmentForm.get('departmentName')?.errors?.['pattern']">
                Department Name contains invalid characters.
              </small>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
      <button nz-button nzType="primary" [disabled]="departmentForm.invalid" (click)="handleOk()" [nzLoading]="isConfirmLoading">
        {{ isEditMode ? 'Update' : 'Create' }}
      </button>
    </div>
  </nz-modal>